import React from "react";

function heading() {
  return (
    <div className="header">
      <svg
        className="header-img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 519.38 277.3"
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path d="M24.08 211.37H0V14.68h24.08zm22.16-108.61V14.68h24.08v88.08zm78.98-69.58H85.29V0h22.9v14.68h47.86l-30 88.08h-25.2zm98.36 69.58l-29.8-45.65c-4.11 1.46-5.43 4.84-5.43 11v34.64h-23.78V68.26c0-13.36 6-23.78 19.23-26.42L166 14.68h24.37l26.71 40.81c4.26-1.47 6-4.7 6-10.86V14.68h23.93v31c0 15.41-9.25 22.75-19.52 25.69l20.55 31.41zm295.8-41.25c0 29.51-13.07 41.25-44 41.25h-197.1l-9.84-88.08h23.35l7.48 69.59h171.66c19.24 0 25.4-6.32 25.4-25.25V14.68h23.05zM380.43 14.68H403v74.91h-22.57zM120.49 211.37H96.56v-69.58H44.29v-18.5h76.2zM68.66 161v50.35H44.59V161zm150.92 4v46.39h-43.16v-18.5h19.08v-27.3c0-16.74-3.82-23.78-17.18-23.78h-4.55L162 211.37h-24.19l12.33-69.58H139v-18.5h43.75c26.4 0 36.83 12.04 36.83 41.71zm75.16 46.37l-29.8-45.65c-4.11 1.46-5.43 4.84-5.43 11v34.64h-23.79v-34.5c0-13.36 6-23.78 19.24-26.42l-17.77-27.16h24.37l26.72 40.81c4.26-1.47 6-4.7 6-10.86v-29.94h23.93v31c0 15.42-9.25 22.76-19.53 25.7l20.56 31.41zm125.07-50.65v50.65h-24.07v-48.44c0-15.71-4.41-21.14-16.74-21.14h-10.42v69.58h-38.46v-18.5h15.56v-51.08h-10.43v-18.5h49c25.29 0 35.56 9.98 35.56 37.43zm94.69 50.65h-23.93v-69.58h-52.26v-18.5h76.19zM462.68 161v50.35H438.6V161z" />
            <path d="M336.99 277.3h25.32L191.79 14.73h-25.33L336.99 277.3z" />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default heading;
